import { createSelector } from 'reselect';
import { FileUploadStatus } from '../enums';
import { getFileInfoState } from './getFileInfoState';
import { isFileStateEmpty } from './isFileStateEmpty';
export const isAllUploadComplete = createSelector([getFileInfoState, isFileStateEmpty], (state, isStateEmpty) => {
    if (isStateEmpty) {
        return false;
    }
    for (let i = 0; i < state.allIds.length; i++) {
        const fileInfo = state.byId[state.allIds[i]];
        if (fileInfo.uploadStatus === FileUploadStatus.IN_PROGRESS || fileInfo.uploadStatus === FileUploadStatus.READY) {
            return false;
        }
    }
    return true;
});
//# sourceMappingURL=isAllUploadComplete.js.map